/**
 * Client Success → Surface (ADR-0077) — landing tab; page placeholder.
 *
 * The Surface is the landing tab for Client Success (`/firm-success` lands
 * here). The tab is in front because that's where attention goes — outstanding
 * work surfaces here for LegalFlare staff. The PAGE itself is still a
 * placeholder while its content is being designed; the tab is in front because
 * of where it's going, not because it's built today.
 *
 * Design needs its own walkthrough of how LegalFlare staff actually hand work
 * back and forth today (inbox / Slack). Do not flesh out without that
 * walkthrough.
 *
 * The Surface task engine is shared infrastructure: when it lands, it
 * generalises the Operations Surface task model (ADR-0057) — a task linking to
 * a Lead, a Firm, a User, or nothing, scoped by `Tasks.Component`. See ADR-0077.
 */

import { ClientSuccessNav } from "@/components/client-success-nav";

export function ClientSuccessSurfacePage() {
  return (
    <section className="mx-auto max-w-4xl p-6" data-testid="firm-success-surface">
      <ClientSuccessNav active="surface" />
      <div
        className="flex min-h-[50vh] flex-col items-center justify-center gap-2 text-center"
        data-testid="firm-success-surface-placeholder"
      >
        <p className="text-lg font-medium text-plane-foreground">Surface — coming later</p>
        <p className="max-w-md text-sm text-plane-muted">
          The shared place to hand off work and watch firm/user threads. It's the
          last build phase — after the firm/user actions are wired — built from a
          walkthrough of how work is handed off today, not designed ahead of it.
        </p>
      </div>
    </section>
  );
}
